// as number of campaigns increase, consider replacing this with a datasource on variera
export const campaignDataFiles = Object.freeze({
    BTC_CHECKLIST: "https://www.ikea.com/global/assets/variera/get-to-the-shoppa/btc-checklist/data.json"
});

// as number of campaigns increase, consider using "localStorageKeyPrefix" object and hardcode "checked-items"
// @TODO will also need to add a uselocalStorage hook to get correct key per project
export const localStorageKeys = Object.freeze({
    BTC_LOCAL_STORAGE_KEY: "btc-checklist-checked-items"
}) 

export const MEDIA_QUERY_FOR_DESKTOP_VIEW = "(min-width: 900px)";
export const DEBOUNCE_AUTOSAVE_DELAY_MS = 600;
export const IKEA_FAMILY_REDIRECT_URL = `https://${window.location.hostname}/us/en/profile/login/?from=https://${window.location.hostname}/us/en/campaigns/back-to-college/college-checklist-pub861552a0`;

/****************************  REDUCER  ACTIONS   ****************************/
export const checklistActions = Object.freeze({
    RESET_STATE: "RESET_STATE",
    SET_USER_CHECKED_ITEMS: "SET_USER_CHECKED_ITEMS",
    SET_USER_TOKEN: "SET_USER_TOKEN",
    SET_CAMPAIGN_DATA: "SET_CAMPAIGN_DATA",
    TOGGLE_CHECK_ITEM: "TOGGLE_ITEM_CHECK",
    TOGGLE_SUBLIST_CLOSED_STATE: "TOGGLE_SUBLIST_CLOSED_STATE",
    SET_CHECKLIST_ERROR:  "SET_ERROR",
    SET_AUTOSAVE_ERROR: "SET_AUTOSAVE_ERROR",
    SET_LOADING: "SET_LOADING",
    LOG_OUT: "LOG_OUT"
});

/****************************  GOOGLE ANALYTICS EVENTS ****************************/
export const GAEventAction = Object.freeze({
    ITEM_CHECKBOX_CLICK: "item_checkbox_click",
    SUBLIST_LINK_CLICK: "sublist_link_click",
    ITEM_LINK_CLICK: "item_link_click",
    IKEA_FAMILY_SIGN_UP_CLICK: "ikea_family_sign_up_click",
    PDF_DOWNLOAD_CLICK: "pdf_download_click"
});

export const GAEventCategory = Object.freeze({
    CHECKLIST_ACTIONS: "checklist_actions"
});

export const GAEventLabel = Object.freeze({
    ITEM_CHECK: "item_check",
    ITEM_UNCHECK: "item_uncheck",
    SUBLIST_LINK: "sublist_link",
    ITEM_LINK: "item_link",
    IKEA_FAMILY_SIGN_UP: "ikea_family_sign_up",
    PDF_DOWNLOAD: "pdf_download"
});

export const checklistSyncError = "Oh no- we can't save your progress at the moment.";

const enviroments = Object.freeze({
    DEV: "dev",
    PROD: "prod"
})

const getEnviroment = () => {
    if (window.location.hostname === "www.ikea.com") return enviroments.PROD;
    return enviroments.DEV;
}

export const endpoint = `https://api.${getEnviroment()}.checklist.usdh.ikea.net/btc`;
